import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5 6h14v12H5z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
})), 'TabletTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TabletTwoTone.js
// module id = 6692
// module chunks = 2